<template>
  <div class="footer" :style="supressPadding && {padding: 0, marginBottom: bottomPadding ? '60px' : ''}">
    <div class="content">
      <div class="title">Lili Customer Service</div>
      <div><a href="mailto:support@lili.co" target="_blank">Email our support team</a> or call us</div>
      <div>(855) 545-4380</div>
      <div>9:00am-7:00pm EST Monday - Friday</div>
    </div>
    <div class="separator"></div>
    <div class="disclaimer">
      Lili is a financial technology company, not a bank.
      Banking services provided by Sunrise Banks, N.A., Member FDIC.
    </div>
  </div>
</template>
<script>
export default {
  name: 'MobileFooter',
  props: ['supressPadding', 'bottomPadding']
}
</script>
<style lang="scss" scoped>
  .footer {
    display: flex;
    flex-direction: column;
    padding: 0 19px;
    background-color: #fff;
    .content {
      width: 242px;
      margin-top: 4px;
      color: #161919;
      font-family: MetricRRegular;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      .title {
        font-size: 14px;
        font-family: MetricRSemiBold;
        margin-bottom: 0px;
      }
      a {
        color: #0078A7;
        text-decoration: none;
        font-size: 12px;
        font-family: MetricRRegular;
      }
    }
    .separator {
      margin: 16px 0;
      width: 100%;
      height: 1px;
      background-color: #DFE2EB;
    }
    .disclaimer {
      color: #868686;
      font-family: MetricRRegular;
      font-size: 11px;
      font-style: normal;
      font-weight: 400;
      line-height: 120%; /* 13.2px */
      height: 69px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/globalUiComponents/MobileFooter.vue